function ShareIcon() {
  return (
    <span data-icon="true" className="flex size-[12px] shrink-0 items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        fill="currentColor"
        className="size-full"
      >
        <path d="M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z" />
      </svg>
    </span>
  )
}

export default function StatRow({
  testId,
  label,
  help = false,
  share = false,
  value = '-',
  valueClass = 'text-ink',
}) {
  const labelClass = help
    ? 'text-left text-dim transition-colors hover:text-ink text-md cursor-help underline decoration-muted/50 decoration-dotted underline-offset-[3px]'
    : 'text-left text-dim transition-colors hover:text-ink text-md'

  return (
    <div className="group/line flex flex-col gap-1 px-4 py-1.5" data-testid={testId}>
      <div className="flex items-baseline justify-between gap-4">
        <span className="flex min-w-0 items-baseline gap-1.5">
          <span className={labelClass} data-state="closed">
            {label}
          </span>
        </span>
        <span className="flex items-baseline gap-1.5">
          <span
            data-testid={`${testId}-value`}
            className={`text-right tabular-nums text-md ${valueClass}`}
          >
            {value}
          </span>
          {share ? (
            <button
              type="button"
              disabled
              aria-label="Share"
              className="inline-flex size-4 shrink-0 cursor-pointer items-center justify-center self-center text-dim transition-colors hover:text-ink disabled:cursor-default disabled:text-dim/40 disabled:hover:text-dim/40 focus-visible:[outline:2px_solid_var(--color-ink)] focus-visible:outline-offset-2"
            >
              <ShareIcon />
            </button>
          ) : null}
        </span>
      </div>
    </div>
  )
}
